var GLOBAL = {
    clima: {
        pontos: null,
        request: null,
    },
    estacao: {
        pontos: null,
        request: null,
    },
    // Estações públicas de terceiros (modo "Público" do mapa).
    publico: {
        pontos: null,
        request: null,
    },
    // Camada opcional da Defesa Civil (RS), sobreposta ao modo "Público".
    defesaCivil: {
        pontos: null,
        request: null,
    },
    // Camada opcional de avisos do INMET (polígonos), sobreposta ao modo "Público".
    inmet: {
        avisos: null,
        request: null,
    }
};


// Grandezas da Rede Hidrometeorológica da Defesa Civil do RS. As CHAVES são as mesmas que
// o backend devolve em `valores` (DefesaCivilGrandezas.cs) — mudar uma exige mudar as duas.
// `mapa: true` é o que decide quais viram botão lateral no mapa: o painel lateral mostra
// todas, o mapa só as que fazem sentido ler de relance num pin.
export const DEFESA_CIVIL_GRANDEZAS = {
    nivel:        { label: 'Nível do rio',     unit: 'm',      icon: 'fa fa-water',                 color: '#3E97FF', casas: 2, mapa: true,  title: 'Nível do rio' },
    chuva_24h:    { label: 'Chuva (24h)',      unit: 'mm',     icon: 'fa fa-cloud-showers-heavy',   color: '#3B82F6', casas: 1, mapa: true,  title: 'Chuva acumulada em 24h' },
    temperatura:  { label: 'Temperatura',      unit: '°C',     icon: 'fa fa-thermometer-full',      color: '#F49C18', casas: 1, mapa: true,  title: 'Temperatura' },
    vento:        { label: 'Vento',            unit: 'km/h',   icon: 'fa fa-wind',                  color: '#727272', casas: 1, mapa: true,  title: 'Vento (velocidade média)' },
    umidade:      { label: 'Umidade',          unit: '%',      icon: 'fa fa-tint',                  color: '#3E97FF', casas: 0, mapa: true,  title: 'Umidade relativa' },
    pressao:      { label: 'Pressão',          unit: 'hPa',    icon: 'fa fa-gauge',                 color: '#FF3E3E', casas: 1, mapa: true,  title: 'Pressão atmosférica' },
    chuva_1h:     { label: 'Chuva (1h)',       unit: 'mm',     icon: 'fa fa-cloud-rain',            color: '#3B82F6', casas: 1, mapa: false },
    vazao:        { label: 'Vazão',            unit: 'm³/s',   icon: 'fa fa-gauge-high',            color: '#0105F9', casas: 1, mapa: false },
    senstermica:  { label: 'Sensação térmica', unit: '°C',     icon: 'fa fa-temperature-half',      color: '#F49C18', casas: 1, mapa: false },
    radiacao:     { label: 'Radiação solar',   unit: 'kWh/m²', icon: 'fa fa-sun',                   color: '#F4C118', casas: 2, mapa: false },
    vento_max:    { label: 'Vento (rajada)',   unit: 'km/h',   icon: 'fa fa-wind',                  color: '#727272', casas: 1, mapa: false },
    vento_direcao:{ label: 'Direção do vento', unit: '°',      icon: 'fa fa-compass',               color: '#839682', casas: 0, mapa: false },

    // Só aparecem na série horária (/DefesaCivil/{codigo}/Hourly), nunca no pin:
    // 'chuva' é o INCREMENTO da hora (somável); 'chuva_24h' acima é o acumulado que a
    // origem já entrega pronto. São coisas diferentes, por isso as duas chaves.
    chuva:         { label: 'Chuva',           unit: 'mm',     icon: 'fa fa-cloud-showers-heavy',   color: '#3B82F6', casas: 1, mapa: false, soma: true },
    chuva_taxa_max:{ label: 'Chuva (pico)',    unit: 'mm/h',   icon: 'fa fa-gauge-high',            color: '#2563EB', casas: 1, mapa: false },
    nivel_variacao:{ label: 'Variação nível',  unit: 'm',      icon: 'fa fa-arrows-up-down',        color: '#3E97FF', casas: 2, mapa: false },
};

// Severidades dos avisos do INMET. As CHAVES são o `id_severidade` da origem, repassado pelo
// backend (InmetSeveridades.cs) — mudar uma exige mudar as duas.
//
// A COR NÃO VEM DAQUI: cada aviso traz a sua em `cor`, definida pelo INMET, e é ela que o
// mapa desenha. Manter uma paleta paralela aqui daria uma legenda que diverge do polígono no
// dia em que eles trocarem um tom. O que este catálogo guarda é o que a origem NÃO manda:
// ícone e o texto de apoio da legenda.
export const INMET_SEVERIDADES = {
    4: { label: 'Grande Perigo',   icon: 'fa fa-triangle-exclamation', ajuda: 'Risco alto de danos e acidentes' },
    5: { label: 'Perigo',          icon: 'fa fa-circle-exclamation',   ajuda: 'Risco de danos e acidentes' },
    6: { label: 'Perigo Potencial', icon: 'fa fa-circle-info',         ajuda: 'Baixo risco de danos e acidentes' },
};

export default {
    data() {
        return {
            clima: {
                pontos: null,
            },
            estacao:{
                pontos: null,
            },
            publico: {
                pontos: null,
            },
            defesaCivil: {
                pontos: null,
            },
            inmet: {
                avisos: null,
            },
        }
    },
    methods: {
        getPontosFiltrado(data, info, max = null, selected) {
            var res = [];
            for (const ponto of data) {
                if (selected && selected.id == ponto.id) {
                    res.push(ponto);
                } else if (info.latitude_min <= ponto.latitude && info.latitude_max >= ponto.latitude && info.longitude_min <= ponto.longitude && info.longitude_max >= ponto.longitude) {
                    if (!(max != null && max < res.length)) {
                        res.push(ponto);
                    }
                }
            }
            return res;
        },
        getClimaPontos() {
            return new Promise((resolve, reject) => {
                this.urlGet('/WeatherForecast/GetAllWeatherForecast').then((e) => {
                   this.clima.pontos = e.data
                   resolve(e.data);
                }).catch((e) => {
                    reject(e);
                });
            });
        },
        getEstacaoPontos() {
            return new Promise((resolve, reject) => {
                this.urlGet('/Station/GetAllStations').then((e) => {
                    this.estacao.pontos = e.data;
                    resolve(e.data);
                }).catch((e) => {
                    reject(e);
                });
            });
        },

        // Modo "Público" do mapa: estações de terceiros (Defesa Civil / ANA / TideSat)
        // monitoradas pelo serviço na AWS. Aba separada de "Dispositivos" — são estações
        // públicas de rio, não equipamentos do usuário.
        getPublicoPontos() {
            return new Promise((resolve, reject) => {
                this.urlGet('/ExternalDevice/Pins').then((e) => {
                    const pins = (e.data && e.data.data) || [];
                    // Mesmo envelope { data: [...] } dos outros modos — o Dashboard lê `e.data`.
                    const envelope = { data: pins.map((pin) => this.mapExternalPinToPonto(pin)) };
                    this.publico.pontos = envelope;
                    resolve(envelope);
                }).catch((e) => {
                    reject(e);
                });
            });
        },

        // Converte um pin de dispositivo externo para o mesmo shape que o mapa espera de um
        // ponto de estação. 'origem' é o discriminador que o Dashboard usa para escolher
        // ícone/cor e qual aside abrir.
        mapExternalPinToPonto(pin) {
            return {
                origem: 'externo',
                // Prefixo evita colisão de id com os pontos próprios (ambos são numéricos).
                id: 'ext-' + pin.id,
                externalDeviceId: pin.id,
                externalId: pin.externalId,
                fonte: pin.fonte,
                fonteLabel: pin.fonteLabel,
                nome: pin.nome,
                county: [pin.cidade, pin.uf].filter(Boolean).join(' - '),
                cidade: pin.cidade,
                uf: pin.uf,
                rio: pin.rio,
                latitude: pin.latitude,
                longitude: pin.longitude,
                data: pin.ultimaColetaEm,
                statusCheia: pin.statusCheia,
                nivelTendencia: pin.nivelTendencia,
                nivelTaxaHora: pin.nivelTaxaHora,
                // Calculado no servidor (última coleta vs. intervalo declarado pela fonte).
                offline: pin.offline === true,
                intervaloMin: pin.intervaloMin,
                pinValue: pin.pinValue,
                pinUnit: pin.pinUnit,
                pinGrandeza: pin.pinGrandeza,
                // Campos que o pipeline de pin do Dashboard lê nos pontos próprios; valores
                // neutros aqui para não acionar bateria, "público" nem os ramos de sensor.
                qrcodeid: null,
                publico: false,
                acessoCompleto: true,
                compartilhado: false,
                bateriaOnConnect: null,
                sensors: null,
            };
        },

        // Camada da Defesa Civil (RS): estações da Rede Hidrometeorológica, lidas ao vivo
        // pelo backend (que atua como proxy — a API deles não devolve CORS para o front).
        // Some por cima das estações públicas, sem substituí-las.
        getDefesaCivilPontos() {
            return new Promise((resolve, reject) => {
                this.urlGet('/DefesaCivil/Pins').then((e) => {
                    const pins = (e.data && e.data.data) || [];
                    const envelope = { data: pins.map((pin) => this.mapDefesaCivilPinToPonto(pin)) };
                    this.defesaCivil.pontos = envelope;
                    resolve(envelope);
                }).catch((e) => {
                    reject(e);
                });
            });
        },

        // Mesmo shape de ponto dos outros modos. 'origem' é o discriminador que o Dashboard
        // usa para escolher o pin e qual painel lateral abrir.
        mapDefesaCivilPinToPonto(pin) {
            return {
                origem: 'defesacivil',
                // Prefixo evita colisão com os ids numéricos dos pontos próprios e com o
                // 'ext-' das estações de terceiros — as três camadas convivem no mapa.
                id: 'dc-' + pin.codigo,
                codigo: pin.codigo,
                nome: pin.nome,
                county: [pin.regiao, 'RS'].filter(Boolean).join(' - '),
                uf: 'RS',
                regiao: pin.regiao,
                bacia: pin.bacia,
                rio: pin.rio,
                latitude: pin.latitude,
                longitude: pin.longitude,
                altitude: pin.altitude,
                data: pin.ultimaLeituraEm,
                offline: pin.offline === true,
                intervaloMin: pin.intervaloMin,
                valores: pin.valores || {},
                // Campos que o pipeline de pin do Dashboard lê nos pontos próprios; valores
                // neutros aqui para não acionar bateria, "público" nem os ramos de sensor.
                qrcodeid: null,
                publico: false,
                acessoCompleto: true,
                compartilhado: false,
                bateriaOnConnect: null,
                sensors: null,
            };
        },

        // Avisos meteorológicos do INMET, lidos pelo backend (que atua como proxy: a API
        // deles não devolve CORS, e o payload bruto passa de 1 MB por causa das listas de
        // municípios e do ícone em base64 — o backend entrega poucos KB já enxutos).
        //
        // Diferente das outras camadas, o retorno não são pontos: é { avisos, atualizadoEm,
        // degradado }, onde cada aviso traz a geometria GeoJSON da área atingida.
        getInmetAvisos() {
            return new Promise((resolve, reject) => {
                this.urlGet('/Inmet/Avisos').then((e) => {
                    const dados = e.data || {};
                    // Os pictogramas vêm num dicionário à parte, indexado por idIcone: são
                    // ~2,8 KB de base64 cada e vários avisos compartilham o mesmo. Aqui cada
                    // aviso recebe o data URI já resolvido, para o mapa não ter que consultar
                    // o dicionário a cada redesenho.
                    const icones = dados.icones || {};
                    const envelope = {
                        avisos: (dados.avisos || []).map((aviso) => this.mapInmetAviso(aviso, icones)),
                        atualizadoEm: dados.atualizadoEm || null,
                        // Conteúdo servido de uma coleta que falhou: o mapa mostra o último
                        // dado bom e avisa que pode estar velho.
                        degradado: dados.degradado === true,
                    };
                    this.inmet.avisos = envelope;
                    resolve(envelope);
                }).catch((e) => {
                    reject(e);
                });
            });
        },

        // Acrescenta ao aviso o que só o front conhece (ícone da severidade e texto da
        // legenda) e resolve o pictograma do fenômeno, sem tocar no que veio da origem — a
        // cor, em especial, é sempre a do INMET.
        mapInmetAviso(aviso, icones) {
            const meta = INMET_SEVERIDADES[aviso.idSeveridade] || {};
            return {
                ...aviso,
                icon: meta.icon || 'fa fa-circle-exclamation',
                ajuda: meta.ajuda || '',
                // Pictograma do fenômeno (data URI). Ausente quando a origem não mandou
                // ícone para aquele tipo — o mapa então desenha só o polígono.
                pictograma: (icones || {})[aviso.idIcone] || null,
            };
        }
    },
    mounted() {
        // NÃO pré-carregar aqui.
        //
        // Este bloco disparava getClimaPontos + getEstacaoPontos em TODA tela que usa o
        // mixin, mas GLOBAL.*.pontos nunca era preenchido (os loaders escrevem em
        // this.clima/this.estacao, não no GLOBAL). Resultado: duas requisições por mount
        // que ninguém consumia — e que competiam com a carga do modo escolhido, deixando
        // o mapa vazio ou com os pontos do modo anterior ao alternar rápido.
        //
        // Quem precisa dos pontos chama o loader explicitamente (Dashboard.setPontos).
    }
}